/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface StopEventMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic for stop events of the asset
 *
 * ```typescript
 *  import {getStopEventMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getStopEventMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getStopEventMarker = ({
  fillColor = dlsColor('caOrange'),
  borderColor = dlsColor('white'),
  size = 24
}: StopEventMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37563 18.6244 0.00734817 12 0Z' fill='${borderColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2.00619 17.5203 6.47972 21.9938 12 22V22Z' fill='${fillColor}'/>
      <rect x='0.212132' width='1.54915' height='13.1925' rx='0.774575' transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 17.3616 8.03379)' fill='${borderColor}' stroke='${borderColor}' stroke-width='0.3'/>
      <rect x='6.78787' y='7.88379' width='1.54915' height='13.1925' rx='0.774575' transform='rotate(-45 6.78787 7.88379)' fill='${borderColor}' stroke='${borderColor}' stroke-width='0.3'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getStopEventMarker;
